import type { LogFilters } from '@/types/auditLog';

export interface LogEntry { timestamp: string; level: string; message: string }

/** Filters log entries by exact (case-sensitive) level and a case-insensitive message substring; order preserved. */
export function filterLogs(logs: LogEntry[], opts: { level?: string; query?: string }): LogEntry[] {
  if (!Array.isArray(logs)) return [];
  const level = opts?.level ?? '';
  const q = (opts?.query ?? '').trim().toLowerCase();
  return logs.filter(
    (l) => (!level || l.level === level) && (!q || (l.message ?? '').toLowerCase().includes(q)),
  );
}

/** Splits raw log text into lines (LF or CRLF, one trailing empty line dropped) and keeps those matching the query. */
export function filterLogLines(text: string, query: string): string[] {
  if (!text) return [];
  const lines = text.split(/\r?\n/);
  if (lines[lines.length - 1] === '') lines.pop();
  const q = (query ?? '').trim().toLowerCase();
  return q ? lines.filter((l) => l.toLowerCase().includes(q)) : lines;
}

/** True when any filter the audit/request filter bar can set has a value (empty strings count as unset). */
export function hasActiveLogFilters(filters: LogFilters): boolean {
  return (
    filters.api_key_id !== undefined ||
    filters.actor_type !== undefined ||
    filters.action !== undefined ||
    filters.resource_type !== undefined ||
    filters.success !== undefined ||
    filters.method !== undefined ||
    Boolean(filters.from) ||
    Boolean(filters.to) ||
    Boolean(filters.q)
  );
}
